const state = {
  // 接口状态, code: 状态码, msg: 描述信息
  status: {
    code: 0,
    msg: '发生错误'
  },
  isWeiXin: false,
  user: {},
  filters: [], // 用于首页搜索的过滤条件
  needLogin: false,
  duration: 0 // 观看视频的时长
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js